export const COLORS = {
    MAIN: '#321e31',
    PURPLE: '#56376e',
    SECONDARY: '#eaeaea'
};

export const DRAWER_WIDTH = 330;
export const CLOSED_DRAWER_WIDTH = 60;
